import Axios from 'axios';
import { configuracoesMapper } from '../mappers/configuracoes/configuracoes.mapper';
import { ConfiguracoesMarcaServiceResponse, Service } from './consultar-configuracoes-marca.types';

export const consultarConfiguracoesMarcaService: Service = async ({ urlBase, domain, brand }) => {
  const { data } = await Axios.get<ConfiguracoesMarcaServiceResponse>(`${urlBase}/marca/${brand}/configs`);

  return configuracoesMapper(data, domain);
};
